export interface AccountApplicantDTO {
  applicantId: number
  roles?: string[]
}

export interface AccountDTO {
  applicants?: AccountApplicantDTO[]
  [key: string]: unknown
}

export interface AccountApplicantInput {
  applicantId: number
  roles?: string[]
}

export function reduceAccountDTO(account: AccountDTO): AccountDTO {
  return {
    ...account,
    ...(account.applicants !== undefined
      ? {
          applicants: account.applicants.map(
            (applicant: {applicantId: number; roles?: string[]}) => ({
              applicantId: applicant.applicantId,
              ...(applicant.roles !== undefined ? {roles: applicant.roles} : {})
            })
          )
        }
      : {})
  }
}

export function reduceAccountApplicantDTO(
  applicant: AccountApplicantInput,
  primaryApplicantId?: number
) {
  return {
    applicants: [
      {
        applicantId: applicant.applicantId,
        roles: applicant.roles
      }
    ],
    ...(primaryApplicantId !== undefined ? {primaryApplicantId} : {})
  }
}
